<section class="container flex flex-col">
  <div *ngFor="let slotable of contentModule.slotables;let i = index;"
       class="w-full">
    <app-slot-a053 [slotable]="slotable" [image]="contentModule.image"></app-slot-a053>
  </div>
</section>
